module.exports = __webpack_public_path__ + "static/media/piece3.debf08dc.png";